 //after installing firebase import fire base
 import firebase from 'firebase/app'
 //import fire store to export our db
 import firestore from 'firebase/firestore'

 // Your web app's Firebase configuration copied from birbase after setup
 var firebaseConfig = {
    apiKey: "AIzaSyAOeXXfyDsUgNBw0MMP5L2m2qZl3wJnpt0",
    authDomain: "flash-chat-bfe0e.firebaseapp.com",
    databaseURL: "https://flash-chat-bfe0e.firebaseio.com",
    projectId: "flash-chat-bfe0e",
    storageBucket: "flash-chat-bfe0e.appspot.com",
    messagingSenderId: "876136155051",
    appId: "1:876136155051:web:e67a3d80438d7dac04f4ee"
  };
  // Initialize Firebase by adding this constant
 const firebaseApp =  firebase.initializeApp(firebaseConfig);

 //add this timestamp line to prevent errors in firebase 4.13 and above
 //firebaseApp.firestore().settings({ timestampsInSnapshots: true});
 firebaseApp.firestore().settings({});

 //export database
 export default firebaseApp.firestore();





// WEBPACK FOOTER //
// ./src/firebase/init.js